import { getThemeFromDomain, shouldUseSuryaForMyAccountTheme, THEME_CONFIG } from "@tSurya/theme/design";
import React, { useEffect, useRef } from "react";

interface ThemeFontLoaderProps {
    hostname?: string;
}

const ThemeFontLoader: React.FC<ThemeFontLoaderProps> = ({ hostname }) => {
    const fontLinksAddedRef = useRef<Set<string>>(new Set());
    const pathname = typeof window !== "undefined" ? window.location.pathname || "" : "";

    useEffect(() => {
        const currentHostname = hostname || (typeof window !== "undefined" ? window.location.hostname : "");

        if (!currentHostname) {
            return;
        }

        const domainThemeKey = getThemeFromDomain(currentHostname);
        const themeKey = shouldUseSuryaForMyAccountTheme(domainThemeKey, pathname) ? "surya" : domainThemeKey;
        const themeConfig = THEME_CONFIG[themeKey];
        const fontUrl = themeConfig.design.TYPOGRAPHY.fontFamilyImportUrl;

        if (!fontLinksAddedRef.current.has(fontUrl)) {
            const existingLink = document.querySelector(`link[href="${fontUrl}"]`);

            if (!existingLink) {
                const link = document.createElement("link");
                link.href = fontUrl;
                link.rel = "stylesheet";
                link.type = "text/css";
                link.setAttribute("data-theme", themeKey);

                document.head.appendChild(link);
                fontLinksAddedRef.current.add(fontUrl);
            }
        }

        return () => {
        };
    }, [hostname, pathname]);

    return null;
};

export default ThemeFontLoader;